import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Drawer,
  List,
  Box,
  useTheme,
  Typography,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import LogoSvg from '@/assets/assetfi/Logo';
import CommonButton from '@/component/pools/CommonButton';
import WalletMenu from '@/component/pools/WalletMenu';
import CloseSvg from '@/assets/assetfi/Close';
import UserSvg from '@/assets/assetfi/User';
import UserFiledSvg from '@/assets/assetfi/UserFilled';
import LayersFiledSvg from '@/assets/assetfi/LayersFilled';
import LayersSvg from '@/assets/assetfi/Layers';
import HamburgerSvg from '@/assets/assetfi/Hamburger';
// import { useWeb3 } from '@/hooks/use-web3';
import { ShortenAddr } from '@/lib/Shorten';
import packageJson from '../../package.json';

const Navbar = () => {
  const version = packageJson.version;
  const theme = useTheme();

  const navigate = useNavigate();
  const location = useLocation();
  // const { web3authCall } = useWeb3();

  // state
  const [address, setAddress] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});
  const open = Boolean(anchorEl);

  // useEffect(() => {
  //   if (address) {
  //     return;
  //   }
  //   (async () => {
  //     if (web3authCall?.connected()) {
  //       const addr = await web3authCall.getAddress();
  //       setAddress(addr);
  //     }
  //   })();
  //   return () => {};
  // }, [web3authCall, address]);

  // method
  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (menuId: string) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

  const NAVBAR_MENU = [
    {
      id: 'Dashboard',
      icon: location.pathname.startsWith('/dashboard') ? <LayersFiledSvg /> : <LayersSvg />,
      text: 'Dashboard',
      location: '/dashboard',
      subItems: [],
    },
    {
      id: 'Factory',
      icon:
        location.pathname.startsWith('/create-factory') || location.pathname.startsWith('/factory-list') ? (
          <UserFiledSvg />
        ) : (
          <UserSvg />
        ),
      text: 'Factory',
      location: '/create-factory',
      subItems: [
        {
          id: 'Create-Factory',
          text: 'Create-Factory',
          location: '/create-factory',
        },
        {
          id: 'Factory-List',
          text: 'Factory-List',
          location: '/factory-list',
        },
      ],
    },
    {
      id: 'Pool',
      icon:
        location.pathname.startsWith('/create-pool') ||
        location.pathname.startsWith('/pool-list') ||
        location.pathname.startsWith('/pool-reward-list') ? (
          <UserFiledSvg />
        ) : (
          <UserSvg />
        ),
      text: 'Pool',
      location: '/create-pool',
      subItems: [
        {
          id: 'Create-Pool',
          text: 'Create-Pool',
          location: '/create-pool',
        },
        {
          id: 'Pool-List',
          text: 'Pool-List',
          location: '/pool-list',
        },
        {
          id: 'Pool-Reward-List',
          text: 'Pool-Reward-List',
          location: '/pool-reward-list',
        },
      ],
    },
    {
      id: 'Stake',
      icon:
        location.pathname.startsWith('/user-dashboard') ||
        location.pathname.startsWith('/add-user-stake') ||
        location.pathname.startsWith('/add-user-reward') ? (
          <UserFiledSvg />
        ) : (
          <UserSvg />
        ),
      text: 'Stake',
      location: '/user-dashboard',
      subItems: [
        {
          id: 'User-Dashboard',
          text: 'User-Dashboard',
          location: '/user-dashboard',
        },
        {
          id: 'Add-User-Stake',
          text: 'Add-User-Stake',
          location: '/add-user-stake',
        },
        {
          id: 'Add-User-Reward',
          text: 'Add-User-Reward',
          location: '/add-user-reward',
        },
      ],
    },
    {
      id: 'Point',
      icon:
        location.pathname.startsWith('/point-setting-list') ||
        location.pathname.startsWith('/point-user-list') ||
        location.pathname.startsWith('/point-user-ledger-list') ||
        location.pathname.startsWith('/add-user-point') ||
        location.pathname.startsWith('/point-staking-list') ? (
          <UserFiledSvg />
        ) : (
          <UserSvg />
        ),
      text: 'Point',
      location: '/point-setting-list',
      subItems: [
        {
          id: 'Point-Setting-List',
          text: 'Point-Setting-List',
          location: '/point-setting-list',
        },
        {
          id: 'Point-User-List',
          text: 'Point-User-List',
          location: '/point-user-list',
        },
        {
          id: 'Point-User-ledger-List',
          text: 'Point-User-Ledger-List',
          location: '/point-user-ledger-list',
        },
        {
          id: 'Add-User-Point',
          text: 'Add-User-Point',
          location: '/add-user-point',
        },
        {
          id: 'Point-Staking-List',
          text: 'Point-Staking-List',
          location: '/point-staking-list',
        },
      ],
    },

    {
      id: 'Bet',
      icon:
        location.pathname.startsWith('/bet-game-dashboard') ||
        location.pathname.startsWith('/bet-game-setting-list') ||
        location.pathname.startsWith('/jackpot-list') ||
        location.pathname.startsWith('/win-history-list') ||
        location.pathname.startsWith('/add-bet-point') ||
        location.pathname.startsWith('/add-jackpot-wallet') ||
        location.pathname.startsWith('/swap-list') ? (
          <UserFiledSvg />
        ) : (
          <UserSvg />
        ),
      text: 'Bet',
      location: '/bet-game-type',
      subItems: [
        {
          id: 'Bet-Game-Dashboard',
          text: 'Bet-Game-Dashboard',
          location: '/bet-game-dashboard',
        },
        {
          id: 'Bet-Game-Setting-List',
          text: 'Bet-Game-Setting-List',
          location: '/bet-game-setting-list',
        },

        {
          id: 'Swap-List',
          text: 'Swap-List',
          location: '/swap-list',
        },
        {
          id: 'Jackpot-List',
          text: 'Jackpot-List',
          location: '/jackpot-list',
        },
        {
          id: 'Win-History-List',
          text: 'Win-History-List',
          location: '/win-history-list',
        },
        {
          id: 'Add-Jackpot-Point',
          text: 'Add-Jackpot-Point',
          location: '/add-jackpot-point',
        },
        {
          id: 'Add-Bet-Point',
          text: 'Add-Bet-Point',
          location: '/add-bet-point',
        },
        {
          id: 'Add-Jackpot-Wallet',
          text: 'Add-Jackpot-Wallet',
          location: '/add-jackpot-wallet',
        },
      ],
    },
    {
      id: 'Upload',
      icon:
        location.pathname.startsWith('/excel-upload-point') ||
        location.pathname.startsWith('/excel-upload-reward') ||
        location.pathname.startsWith('/excel-upload-bet') ||
        location.pathname.startsWith('/excel-upload-bet-swap') ? (
          <UserFiledSvg />
        ) : (
          <UserSvg />
        ),
      text: 'Upload',
      location: '/excel-upload-point',
      subItems: [
        {
          id: 'Excel-Upload-Point',
          text: 'Excel-Upload-Point',
          location: '/excel-upload-point',
        },
        {
          id: 'Excel-Upload-Reward',
          text: 'Excel-Upload-Point-Reward',
          location: '/excel-upload-reward',
        },
        {
          id: 'Excel-Upload-Bet',
          text: 'Excel-Upload-Bet',
          location: '/excel-upload-bet',
        },
        {
          id: 'Excel-Upload-Bet-Swap',
          text: 'Excel-Upload-Bet-Swap',
          location: '/excel-upload-bet-swap',
        },
      ],
    },
    {
      id: 'Addresses',
      icon: location.pathname.startsWith('/addresses') ? <UserFiledSvg /> : <UserSvg />,
      text: 'Addresses',
      location: '/addresses',
      subItems: [],
    },
    {
      id: 'Admin-List',
      icon: location.pathname.startsWith('/admin-list') ? <UserFiledSvg /> : <UserSvg />,
      text: 'Admin-List',
      location: '/admin-list',
      subItems: [],
    },
    {
      id: 'Version',
      icon: location.pathname.startsWith('/version-list') ? <UserFiledSvg /> : <UserSvg />,
      text: 'Version-List',
      location: '/version-list',
      subItems: [],
    },
    {
      id: 'Stake-db',
      icon: location.pathname.startsWith('/stake-db') ? <UserFiledSvg /> : <UserSvg />,
      text: 'Stake-db',
      location: '/stake-db-pool-list',
      subItems: [
        {
          id: 'Stake-db-Dashboard',
          text: 'Dashboard',
          location: '/stake-db-dashboard',
        },
        {
          id: 'Stake-db-Pool-List',
          text: 'Pool-List',
          location: '/stake-db-pool-list',
        },
        {
          id: 'Stake-db-Pool-Create',
          text: 'Pool-Create',
          location: '/stake-db-pool-create',
        },
        {
          id: 'Stake-db-Add-Position',
          text: 'Add-Position',
          location: '/stake-db-add-position',
        },
        {
          id: 'Stake-db-Add-Reward',
          text: 'Add-Reward',
          location: '/stake-db-manual-reward',
        },
        {
          id: 'Stake-db-Admin-Wallet',
          text: 'Admin-Wallet',
          location: '/stake-db-admin-wallet',
        },
        {
          id: 'Stake-db-Coin-Type',
          text: 'Coin-Type',
          location: '/stake-db-coin-type',
        },
      ],
    },
  ];

  return (
    <>
      {/* 헤더 */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          borderBottom: `0.5px solid #d9d9d9`,
          display: { xs: 'flex', md: 'none' },
        }}
      >
        <Toolbar
          sx={{
            padding: '16px 24px',
            justifyContent: 'space-between',
            background: '#ffffff',
          }}
        >
          <IconButton aria-label="open drawer" edge="start" onClick={handleDrawerToggle}>
            <HamburgerSvg />
          </IconButton>

          <CommonButton
            bgColor={address ? '#ffffff' : theme.brand.primary}
            color={address ? theme.background.blue : '#ffffff'}
            text={address ? ShortenAddr(address) : 'Connect Wallet'}
            handleClick={handleClick}
            variant={address ? 'h6' : 'subtitle2'}
            sx={{
              height: '32px',
              borderRadius: '20px',
              padding: '6px 20px 6px 20px',
              boxShadow: address ? '0px 0px 4px 0px #00000026' : 'none',
            }}
            icon={address ? 'symbol' : null}
          />
        </Toolbar>
      </AppBar>
      <WalletMenu open={open} anchorEl={anchorEl} handleClose={handleClose} />
      {/* 햄버거 */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '100%' },
        }}
      >
        <Box
          sx={{
            padding: '16px',
            borderBottom: '0.5px solid #D9D9D9',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <IconButton aria-label="close drawer" edge="start" onClick={handleDrawerToggle}>
            <CloseSvg width={24} height={24} />
          </IconButton>

          <CommonButton
            bgColor={address ? '#ffffff' : theme.brand.primary}
            color={address ? theme.background.blue : '#ffffff'}
            text={address ? ShortenAddr(address) : 'Connect Wallet'}
            handleClick={handleClick}
            variant={address ? 'h6' : 'subtitle2'}
            sx={{
              height: '32px',
              borderRadius: '20px',
              padding: '6px 20px 6px 20px',
              boxShadow: address ? '0px 0px 4px 0px #00000026' : 'none',
            }}
            icon={address ? 'symbol' : null}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '10px',
            flexDirection: 'column',
            padding: '32px 16px',
          }}
        >
          <Typography
            sx={{
              color: location.pathname.startsWith('/pools') ? theme.background.blue : theme.greyscale.darkgrey2,
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '32px',
              lineHeight: '42px',
              letterSpacing: '-0.02em',
            }}
            color={theme.greyscale.darkgrey2}
            onClick={() => {
              navigate('/pools');
              handleDrawerToggle();
            }}
          >
            Pools
          </Typography>
          <Typography
            sx={{
              color: location.pathname.startsWith('/portfolio') ? theme.background.blue : theme.greyscale.darkgrey2,
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '32px',
              lineHeight: '42px',
              letterSpacing: '-0.02em',
            }}
            color={theme.greyscale.darkgrey2}
            onClick={() => {
              navigate('/portfolio');
              handleDrawerToggle();
            }}
          >
            Portfolio
          </Typography>
        </Box>
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            right: 0,
            margin: 2, // Optional: adds some margin from the bottom and right edge
          }}
        >
          <Typography variant="body1">version: {version}</Typography>
        </Box>
      </Drawer>
      {/* 좌측 네비게이션 바 */}
      <Box
        sx={{
          width: '300px',
          height: '100%',
          borderRight: `0.5px solid ${theme.greyscale.lightgrey1}`,
          display: { xs: 'none', md: 'block' },
        }}
      >
        <Box
          sx={{
            boxShadow: '0px 0px 8px 0px #00000026',
            height: '64px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <LogoSvg />
          {/* <UserFilled width="150" height="150" /> */}
          {/* <UserFilled /> */}
        </Box>
        <List
          sx={{
            padding: '24px',
            gap: '10px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {NAVBAR_MENU.map((menu) => (
            <React.Fragment key={menu.id}>
              <ListItemButton
                onClick={() => {
                  if (menu.subItems.length > 0) {
                    handleMenuClick(menu.id);
                  } else {
                    navigate(menu.location);
                  }
                }}
                sx={{
                  padding: '2px 0px 2px 20px',
                  gap: '16px',
                  borderRadius: '5px',
                  background: location.pathname.startsWith(menu.location) ? '#357AFF1A' : '#ffffff',
                  '&:hover': {
                    background: location.pathname.startsWith(menu.location) ? '#357AFF1A' : '#f5f5f5',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 'auto' }}>{menu.icon}</ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: '18px',
                        color: location.pathname.startsWith(menu.location)
                          ? theme.background.blue
                          : theme.greyscale.darkgrey2,
                      }}
                    >
                      {menu.text}
                    </Typography>
                  }
                />
                {menu.subItems.length > 0 && (openMenus[menu.id] ? <ExpandLess /> : <ExpandMore />)}
              </ListItemButton>

              {menu.subItems.length > 0 && (
                <Collapse in={openMenus[menu.id]} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {menu.subItems.map((subItem) => (
                      <ListItemButton
                        key={subItem.id}
                        onClick={() => navigate(subItem.location)}
                        sx={{
                          pl: 6,
                          padding: '2px 0px 2px 20px',
                          gap: '16px',
                          borderRadius: '5px',
                          background: location.pathname.startsWith(subItem.location) ? '#357AFF1A' : '#ffffff',
                          '&:hover': {
                            background: location.pathname.startsWith(subItem.location) ? '#357AFF1A' : '#f5f5f5',
                          },
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontWeight: 600,
                                fontSize: '16px',
                                color: location.pathname.startsWith(subItem.location)
                                  ? theme.background.blue
                                  : theme.greyscale.darkgrey2,
                              }}
                            >
                              {subItem.text}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            margin: 2, // Optional: adds some margin from the bottom and right edge
          }}
        >
          <Typography variant="body1">version: {version}</Typography>
        </Box>
      </Box>
    </>
  );
};

export default Navbar;
